<template>
    <v-sheet
        ref="dropzone"
        tabindex="0"
        :title="tooltip"
        color="grey lighten-4"
        style="cursor:pointer"
        class="pa-2 fill-height pb-6 mb-6"
        :class="{'error':error}"
    >
        <input :error="error" :error-messages="errorMessages" ref="fileUpload" type="file" class="d-none" multiple />
        <slot>
            <v-row justify="center" align="center" class="fill-height">
                <v-col class="text-center">
                    <template v-if="value.length > 0">
                        <v-chip
                            class="ma-1"
                            v-for="file in value"
                            :key="file.filename"
                            :close="file.isComplete && !file.isInProgress"
                            close-icon="mdi-delete"
                            @click:close="removeFile(file)"
                        >
                            {{ file.filename }}
                            <v-progress-circular
                                v-if="file.isInProgress"
                                class="ml-2"
                                size="24"
                                indeterminate
                            ></v-progress-circular>
                            <v-progress-circular-ext
                                v-if="!file.isComplete"
                                class="ml-2"
                                size="24"
                                :value="file.percentCompleted"
                                @complete="file.isComplete = true"
                            ></v-progress-circular-ext>
                        </v-chip>
                    </template>
                    <template v-else>
                        <v-icon v-if="!dragOver" class="d-block" color="grey" size="75">mdi-paperclip</v-icon>
                        <v-icon v-if="dragOver" class="d-block" color="grey" size="75">mdi-plus</v-icon>
                    </template>
                    <div class="title grey--text d-block">{{ label }}</div>
                </v-col>
            </v-row>
        </slot>
        <v-row v-if="error">
            <br/>
            <p class="error--text pt-6 pl-3">{{errorMessages}}</p>
        </v-row>
    </v-sheet>
</template>

<script>
import VProgressCircularExt from './VProgressCircularExt';

export default {
    name: 'v-file-input-dropzone',
    components: {
        VProgressCircularExt,
    },
    props: {
        label: String,
        tooltip: String,
        value: Array,
        error: Boolean,
        errorMessages:String,
    },
    data: () => ({
        dragOver: false,
    }),
    mounted() {
        // to register listeners, we have to know the
        // html elements
        const dropzone = this.$refs.dropzone.$el;
        const fileUpload = this.$refs.fileUpload;

        // register listeners on your dropzone / v-sheet
        if (dropzone) {
            // register all drag & drop event listeners
            dropzone.addEventListener('dragenter', e => {
                e.stopPropagation();
                e.preventDefault();
                this.dragOver = true;
            });
            dropzone.addEventListener('dragleave', e => {
                e.stopPropagation();
                e.preventDefault();
                this.dragOver = false;
            });
            dropzone.addEventListener('dragover', e => {
                e.stopPropagation();
                e.preventDefault();
                this.dragOver = true;
            });
            dropzone.addEventListener('drop', e => {
                e.stopPropagation();
                e.preventDefault();
                const dragEvent = e;

                if (dragEvent.dataTransfer) {
                    this.dragOver = false;
                    this.addFiles(dragEvent.dataTransfer.files);
                }
            });

            // register event listener for keyboard usage
            dropzone.addEventListener('click', e => {
                if (e.target !== fileUpload) {
                    e.stopPropagation();
                    e.preventDefault();
                    fileUpload.click();
                }
            });
            dropzone.addEventListener('keypress', e => {
                e.stopPropagation();
                e.preventDefault();
                const keyEvent = e;
                if (keyEvent.key === 'Enter') {
                    fileUpload.click();
                }
            });

            // register listeners on the file input
            fileUpload.addEventListener('change', e => {
                const target = e.target;

                if (target.files) {
                    this.addFiles(target.files);
                    //this.filesSelected(target.files);
                }
            });
        }
    },
    methods: {
        addFiles(fileList) {
            const that = this;

            Array.from(fileList).forEach(function(file) {
                that.$emit('file-added', file);
            });
        },
        removeFile(file) {
            this.$emit('file-removed', file);
        },
    },
};
</script>
